// features/pricing/model/PricingState.ts
import { PricingPlan, CurrentPlan } from './PricingModel';

export interface PricingState {
  plans: PricingPlan[];
  currentPlan: CurrentPlan | null;
  isLoading: boolean;
  error: string | null;
}

export const initialPricingState: PricingState = {
  plans: [],
  currentPlan: null,
  isLoading: true,
  error: null,
};

// Action Types
export enum PricingActionType {
  FETCH_START = 'FETCH_START',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_ERROR = 'FETCH_ERROR',
  FETCH_CURRENT_PLAN_SUCCESS = 'FETCH_CURRENT_PLAN_SUCCESS',
  RESET = 'RESET',
}

// Action Interfaces
export interface FetchStartAction {
  type: PricingActionType.FETCH_START;
}

export interface FetchSuccessAction {
  type: PricingActionType.FETCH_SUCCESS;
  payload: PricingPlan[];
}

export interface FetchErrorAction {
  type: PricingActionType.FETCH_ERROR;
  payload: string;
}

export interface FetchCurrentPlanSuccessAction {
  type: PricingActionType.FETCH_CURRENT_PLAN_SUCCESS;
  payload: CurrentPlan;
}

export interface ResetAction {
  type: PricingActionType.RESET;
}

export type PricingAction = 
  | FetchStartAction 
  | FetchSuccessAction 
  | FetchErrorAction 
  | FetchCurrentPlanSuccessAction
  | ResetAction;

// Reducer
export const pricingReducer = (state: PricingState, action: PricingAction): PricingState => {
  switch (action.type) {
    case PricingActionType.FETCH_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    
    case PricingActionType.FETCH_SUCCESS:
      return {
        ...state,
        plans: action.payload,
        isLoading: false,
        error: null,
      };
    
    case PricingActionType.FETCH_CURRENT_PLAN_SUCCESS:
      return {
        ...state,
        currentPlan: action.payload,
      };
    
    case PricingActionType.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        plans: [],
      };
    
    case PricingActionType.RESET:
      return initialPricingState;
    
    default:
      return state;
  }
};

// Action Creators
export const fetchStart = (): FetchStartAction => ({
  type: PricingActionType.FETCH_START,
});

export const fetchSuccess = (plans: PricingPlan[]): FetchSuccessAction => ({
  type: PricingActionType.FETCH_SUCCESS,
  payload: plans,
});

export const fetchError = (error: string): FetchErrorAction => ({
  type: PricingActionType.FETCH_ERROR,
  payload: error,
});

export const fetchCurrentPlanSuccess = (currentPlan: CurrentPlan): FetchCurrentPlanSuccessAction => ({
  type: PricingActionType.FETCH_CURRENT_PLAN_SUCCESS,
  payload: currentPlan,
});

export const resetPricing = (): ResetAction => ({
  type: PricingActionType.RESET,
});